// CSS var used for fixed app header/AppBar height.
export const DEFAULT_APP_BAR_HEIGHT = 65;
export const APP_HEADER_OFFSET_VAR = 'var(--app-header-offset)';

// Default ID for the primary main landmark; used by skip-to-main links.
export const MAIN_CONTENT_ID = 'main-content';

// Scroll margin so skip-to-main doesn't land under the AppBar.
export const MAIN_SCROLL_MARGIN_TOP = `calc(${APP_HEADER_OFFSET_VAR} + 16px)`;
